import { addBreadcrumb, captureMessage } from '../lib/sentry';
import * as Sentry from '@sentry/react';

/**
 * Internal (never user-facing) diagnostics for a terminal Auto-Fix result.
 *
 * The screen keeps one simple message per terminal `status`; the backend's
 * machine `reason` (e.g. canonical_macro_mismatch, stale_saved_day,
 * uniqueness_group_violation) is preserved here so the next recurrence is
 * distinguishable immediately. Only the closed, non-PII enums status /
 * reason / strategy are sent -- never meals, macros, dates or user data.
 *
 * Every terminal result leaves a breadcrumb; a non-success result is also a
 * warning-level Sentry message tagged with the three enums.
 */
export var AUTO_FIX_SUCCESS_STATUSES = ['fixed', 'already_good'];

export function autoFixDiagnosticTags(result) {
  var data = result || {};
  return {
    auto_fix_status: String(data.status || 'unknown'),
    auto_fix_reason: String(data.reason || 'none'),
    auto_fix_strategy: String(data.strategy || 'none'),
  };
}

export function reportAutoFixTerminal(result) {
  try {
    var tags = autoFixDiagnosticTags(result);
    addBreadcrumb('auto_fix', 'Auto-Fix terminal ' + tags.auto_fix_status, tags);
    if (AUTO_FIX_SUCCESS_STATUSES.indexOf(tags.auto_fix_status) !== -1) return;
    if (Sentry && typeof Sentry.withScope === 'function') {
      Sentry.withScope(function (scope) {
        Object.keys(tags).forEach(function (key) { scope.setTag(key, tags[key]); });
        scope.setLevel('warning');
        Sentry.captureMessage('auto_fix_terminal_' + tags.auto_fix_status);
      });
    } else {
      captureMessage('auto_fix_terminal_' + tags.auto_fix_status, 'warning');
    }
  } catch (e) {
    // diagnostics must never affect the screen
  }
}
